import React, { ReactElement, Suspense, useCallback } from 'react';
import { useConnectorUIState } from '../../../uiState/contexts';
import DestinationCarroussel from './main';
import {
  DestinationSelectorContainer,
  DestinationSelectorTitle,
} from './styles.index';
import DestinationCarrouselSkeletons from './skeleton';

//@TODO: Implement SourceSelector component
/**
 * SourceSelector component allows users to choose a source from a list of available sources.
 *
 * This component uses the `useConnectorUIState` hook
 * to get the currently selected source. It then renders a list of `SourceCard` components inside a `SourceCarroussel`.
 *
 * @component
 * @returns {JSX.Element} The rendered component.
 */
const DestinationSelector: React.FC = (): ReactElement => {
  const [connectorState, setConnectorState] = useConnectorUIState();

  const handleOnClickDestination = useCallback((destination) => {
    const { name, provider, displayName } = destination;
    const chosenDestination = {
      destinationName: name,
      chosenTables: [],
      provider,
      displayName,
    };
    setConnectorState((prev) => ({ ...prev, chosenDestination }));
  }, []);

  return (
    <DestinationSelectorContainer>
      <DestinationSelectorTitle>Choose a destination:</DestinationSelectorTitle>

      <Suspense fallback={<DestinationCarrouselSkeletons />}>
        <DestinationCarroussel
          chosenDestination={connectorState.chosenDestination}
          editDestination={connectorState.editDestination}
          onChooseDestination={handleOnClickDestination}
        />
      </Suspense>
    </DestinationSelectorContainer>
  );
};

export default DestinationSelector;
